// caseAPI.js - API service for case management
import { fetchWithAuth } from "../apiutil";

export const caseAPI = {
  loadCase: async (accessToken, caseId) => {
    console.log(`[caseAPI.loadCase] loading case: ${caseId}`);
    return fetchWithAuth(
      `/api/cases/${caseId}`,
      { method: "GET" },
      accessToken
    );
  },

  createCase: async (accessToken, caseData) => {
    console.log("[caseAPI.createCase] creating case", caseData);
    return fetchWithAuth(
      "/api/cases",
      {
        method: "POST",
        body: JSON.stringify(caseData),
      },
      accessToken
    );
  },

  updateMetadata: async (accessToken, caseData) => {
    console.log("[caseAPI.updateMetadata] updating case", caseData);
    return fetchWithAuth(
      `/api/cases/${caseData.id}`,
      {
        method: "PUT",
        body: JSON.stringify(caseData),
      },
      accessToken
    );
  },

  deleteCase: async (accessToken, caseData) => {
    console.log(`[caseAPI.deleteCase] deleting case: ${caseData.id}`);
    return fetchWithAuth(
      `/api/cases/${caseData.id}`,
      {
        method: "DELETE",
      },
      accessToken
    );
  },

  emptyTrash: async (accessToken, caseData) => {
    console.log(`[caseAPI.emptyTrash] emptying trash for case: ${caseData.id}`);
    return fetchWithAuth(
      `/api/cases/${caseData.id}/trash`,
      {
        method: "DELETE",
      },
      accessToken
    );
  },
};
